import React, { useState, useEffect } from 'react';
import { message, Spin, Tooltip, Switch, Popconfirm, Skeleton, Modal, Image, } from 'components/shared/AntComponent';
import { Button, Form, Select, Input, InputNumber, TimePicker, DatePicker, TextArea, Radio } from 'components/shared/FormComponent';
import { DeleteFilled, DownCircleFilled, DownSquareOutlined, LoadingOutlined, SyncOutlined, ArrowLeftOutlined } from 'components/shared/AntIcons';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getQuestionPaper } from 'services/store/actions/questionPaperAction';
import { addExam, autoGenerateQuestion, getDeptQuestions, getExamDetail } from 'services/store/actions/examAction';
import dayjs from 'dayjs';
import { getAllApplicant, getApplicantDetails, getApplicantType } from 'services/store/actions/candidateAction';
import { getAccountList } from 'services/store/actions/accountAction';
import AddSlotScreen from '../sub-screens/AddSlotScreen';
import { EditIcon, SendMailIcon, DisableSendMailIcon } from 'assets/icons/CustomIcons';


const NewUpdateExam: React.FC = () => {
    const history = useNavigate();
    const [form] = Form.useForm();
    const location = useLocation();
    const dispatch = useDispatch();
    const { accountInfo, loading: accLoading } = useSelector((state: any) => state.account);
    const { questionpaperData, loading: loadingQuestions } = useSelector((state: any) => state.questionpaper);
    const { candidateData, loading: loadingCandidates, applicantInfo, loading15, appTypeInfo, loading17, loading18, applicantListInfo } = useSelector((state: any) => state.candidate);
    const { success1, loading1, error1, examDetailInfo, loading4, deptQuesInfo, loading12, loading15: autoLoading, autoQuesInfo } = useSelector((state: any) => state.exam);
    const [isAutomate, setIsAutomate] = useState(false);
    const [questionCount, setQuestionCount] = useState(0);
    const [isNegativemark, setIsNegativemark] = useState(false);
    const [totalMark, setTotalMark] = useState(0);
    const [accID, setAccID] = useState(0);
    const [subdept, setSubdept] = useState('');
    const [subdeptOptions, setSubdeptOptions] = useState([]);
    const [expandVal, setExpandVal]: any = useState([]);
    // const apiUrl = window.location.href.startsWith('https://kovina-a8h7dcdshdddhmcy.southindia-01.azurewebsites.net') ? "https://kovina-api-gba4f4drejguf6dy.southindia-01.azurewebsites.net/api/"
    //     : window.location.href.startsWith('https://qa.kovina.com') ? "https://qa-api.kovina.com/api/" : "https://dev-api-v1.kovina.com/api/";
    const [slots, setSlots]: any = useState([]);
    const [questionType, setQuestionType] = useState('1');
    const [fieldType, setFieldType] = useState('core_questions');
    const [openModal, setOpenModal] = useState(false);
    const [isFormReady, setIsFormReady] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [totalMarkA, setTotalMarkA] = useState(0);
    const [forceRenderFlag, setForceRenderFlag] = useState(false);  // Force render
    const [selectedSlots, setSelectedSlots] = useState([]);  // For managing selected slots
    const [selectedCandidates, setSelectedCandidates] = useState(new Set()); // Track selected candidates globally
    const [showSuccessmsg, setShowSuccessmsg] = useState(false);
    const successmsg = showSuccessmsg ? success1 : false;
    const [showErrmsg, setShowErrMsg] = useState(false);
    const errormsg = showErrmsg ? error1 : false;
    const [deptOptions, setDeptOptions] = useState([]);
    const [dept, setDept]: any = useState(null);
    const userID = localStorage.getItem('userid');
    const [isPastDate, setIsPastDate] = useState(false);
    const [showAdd, setShowAdd] = useState(false);
    const autoPapers = !autoLoading && autoQuesInfo ? autoQuesInfo : null;
    const [duration, setDuration] = useState(0);
    const [rowData, setRowData]: any = useState(null);


    const applicantOptions: any = !loading18 && applicantListInfo ? applicantListInfo?.data : [];

    useEffect(() => {
        if (appTypeInfo?.data) {
            const cleanedCourses = appTypeInfo.data.course
                ?.filter((item: any) => {
                    if (!item || typeof item !== 'string') return false;
                    const trimmed = item.trim();
                    // Remove empty, test values, and pure numbers
                    return (
                        trimmed !== '' &&
                        trimmed.toLowerCase() !== 'test_guest' &&
                        isNaN(Number(trimmed))
                    );
                });

            // Deduplicate case-insensitively
            const seen = new Set();
            const uniqueCourses = cleanedCourses.filter((item: string) => {
                const lower = item.toLowerCase();
                if (seen.has(lower)) return false;
                seen.add(lower);
                return true;
            });

            const deptOptions1 = uniqueCourses.map((item: any) => ({
                label: item,
                value: item,
                key: item
            }));

            setDeptOptions(deptOptions1);
        }
    }, [appTypeInfo?.data]);

    const handleShowSlot = () => {
        setShowAdd(true);
        setRowData(null);

    }
    const closeSlot = () => {
        setShowAdd(false);
    }
    const handleOpenModal = () => {
        setOpenModal(true);
        setQuestionType('1');
        setFieldType('core_questions');
    }
    const handleExpand = (id: string) => {
        let myArray = expandVal;
        const valueExists = myArray.includes(id);
        if (!valueExists) {
            myArray = [...myArray, id];
        } else {
            if (myArray.includes(id)) {
                myArray = expandVal.filter((item: any) => item != id);
            }
        }
        setExpandVal(myArray);
    };
    const closeModal = () => {
        setOpenModal(false);
    }

    const accOptions: any = !accLoading ? accountInfo?.AccountDetail?.filter((acc: any) => acc?.status?.toLowerCase() === "active")
        ?.map((acc: any) => {
            return {
                label: acc?.account_name,
                value: acc.id,
                key: acc.id,
            };
        }) : [];

    const sectionOptions1 = !loading12 && deptQuesInfo?.data?.filter((item: any) => item.category_type == "type_1" || item.category_type == 1)
        ?.map((item: any) => {
            return {
                value: item?.id?.toString(),
                label: item?.title,
            }
        });
    const sectionOptions2 = !loading12 && deptQuesInfo?.data?.filter((item: any) => item.category_type !== "type_1" && item.category_type != 1)
        ?.map((item: any) => {
            return {
                value: item?.id?.toString(),
                label: item?.title + " (" + item?.question_paper_subject + ")",
            }
        });
    const sectionOptions3 = !loadingQuestions && questionpaperData?.AccountDetail?.map((item: any) => {
        return {
            value: item?.id?.toString(),
            label: item?.title + " (" + item?.question_paper_subject + ")",
        }
    });

    useEffect(() => {
        if (userID == "6") {
            const inputJson = {
                Input: {
                    status: 'Active',
                },
                DataFinder: {
                    pagesize: 10000,
                    currentpage: 1,
                    sortbycolumn: '',
                    sortby: 'asc',
                    searchdata: '',
                },
            };
            dispatch(getQuestionPaper(inputJson) as any);
        }

    }, [userID]);

    const getAccount = (page: number, size: number) => {
        const inputJson = {
            "AcctInput": {
                "is_active": true,
                "status": "Active"
            },
            "DataFinder": {
                "pagesize": size,
                "currentpage": page,
                "sortbycolumn": "",
                "sortby": "asc",
                "searchdata": ""
            }
        }
        dispatch(getAccountList(inputJson) as any);
    }

    useEffect(() => {
        // if (userID == "6") {
        getAccount(1, 100000);
        // }
    }, []);
    function getCandidate(acc: any, dept: any) {
        const inputJson = {
            Input: {
                status: 'Active',
                accountid: Number(acc) || 0,
                department: dept || ""
            },
            DataFinder: {
                pagesize: 10000,
                currentpage: 1,
                sortbycolumn: '',
                sortby: 'asc',
                searchdata: '',
            },
        };
        dispatch(getAllApplicant(inputJson) as any);
    }

    useEffect(() => {
        if (userID == "6") {
            getCandidate(0, "");
        }
    }, [userID]);

    const handleChangeQuestionA = (value: any) => {
        if (questionpaperData && questionpaperData.AccountDetail) {
            const commonValues = questionpaperData?.AccountDetail.filter((val: any) => value.includes(val?.id.toString())).map((item: any) => item.total_question);
            const marks = questionpaperData?.AccountDetail.filter((val: any) => value.includes(val.id.toString())).map((item: any) => item.total_marks);
            const sum = commonValues.map(Number).reduce((acc: any, curr: any) => acc + curr, 0);
            const sumMark = marks.map(Number).reduce((acc: any, curr: any) => acc + curr, 0);
            setQuestionCount(sum);
            setTotalMarkA(sumMark);
            form.setFieldsValue({ totalQuestions: sum });
        }
    }

    const handleChangeQuestion = (value: any) => {
        if (questionpaperData && questionpaperData.AccountDetail) {

            const commonValues = questionpaperData?.AccountDetail.filter((val: any) => value.includes(val?.id.toString())).map((item: any) => item.total_question);
            const marks = questionpaperData?.AccountDetail.filter((val: any) => value.includes(val.id.toString())).map((item: any) => item.total_marks);
            const sum = commonValues.map(Number).reduce((acc: any, curr: any) => acc + curr, 0);
            const sumMark = marks.map(Number).reduce((acc: any, curr: any) => acc + curr, 0);
            setQuestionCount(sum);
            setTotalMark(sumMark);
            form.setFieldsValue({ totalQuestions: sum });
        }
    };

    const handleChangeQuestion1 = (value: any) => {
        const question = questionpaperData?.AccountDetail.find((item: any) => item.id == value);
        if (question) {
            setQuestionCount(Math.abs(questionCount - question.total_question));
            setTotalMark(Math.abs(totalMark - question.total_marks));
            form.setFieldsValue({ totalQuestions: Math.abs(questionCount - question.total_question) });
            // setTotalQues()
        }
    };

    const submitForm = async () => {
        try {
            const val = await form.validateFields();
            const options = [];
            if (slots?.length > 0) {
                for (let i = 0; i < slots?.length; i++) {
                    options.push({
                        id: slots[i]?.slotID,
                        slot_start_time: dayjs(slots[i]?.slotStartTime).format('HH:mm:ss'),
                        slot_end_time: dayjs(slots[i]?.slotEndTime).format('HH:mm:ss'),
                        associated_candidates: slots[i]?.associateCandidates?.toString(),
                        location: slots[i]?.location,
                        is_active: slots[i]?.isActive,
                        max_candidates: 30,
                        current_candidates: slots[i]?.associateCandidates?.split(',')?.length || 0,
                        is_online: true,
                        associated_accountid: val.account || "",
                        associated_department: val.department?.toString() || ""
                    })
                }
            }
            const inputJson = {
                examid: location.state.id || 0,
                exam_title: val.examTitle,
                associated_papers: val.automateQuestions && location.state.id == 0 ? "" : val.automateQuestions && location.state.id != 0 ? examDetailInfo?.data?.associated_papers || "" : userID === "6" ? val.questionPapers?.toString() : val.questionPapers?.toString() + "," + val.questionPaperA?.toString() || '',
                description: val.description || '',
                total_marks: totalMark + totalMarkA || 0,
                exam_duration: val.duration || '',
                exam_date: val.examDate ? dayjs(val.examDate).format('YYYY-MM-DD') : '',
                is_negative_mark: val.isNegativeMark || isNegativemark,
                negative_mark: val.negativeMark || null,
                slots: options,
                is_automate_questions: val.automateQuestions || isAutomate,
                associated_accountid: val.account || "",
                associated_department: val.department?.toString() || "",
                section_1_questions: location.state.id != 0 && examDetailInfo?.data?.associated_papers ? "" : autoPapers?.section_1_questions || null,
                section_2_questions: location.state.id != 0 && examDetailInfo?.data?.associated_papers ? "" : autoPapers?.section_2_questions || null
                // associated_candidates: val.associateCandidates?.toString() || '',
            };
            dispatch(addExam(inputJson) as any);
            setShowSuccessmsg(true);
            setShowErrMsg(true);
        }
        catch (errorInfo) {
            console.log('Failed:', errorInfo);
        }
    };

    useEffect(() => {
        if (successmsg) {
            if (location.state.id === 0) {
                message.success('Exam created successfully');
            } else {
                message.success('Exam updated successfully');
            }
            history('/exam');
            setShowSuccessmsg(false);
        }
        if (errormsg) {
            if (errormsg?.data) {
                message?.error(errormsg?.data);
            } else {
                message.error("Exam couldn't be created");
            }
            setShowErrMsg(false);
        }
    }, [successmsg, errormsg]);

    const goToPreviousScreen = () => {
        history('/exam');
    };

    const getDetail = () => {
        dispatch(getExamDetail(location.state.id) as any);
    };

    useEffect(() => {
        if (location.state.id !== 0) {
            getDetail();
        }
    }, [location.state?.id]);
    const disablePastDates = (current: dayjs.Dayjs) => {
        // Disable dates before today
        return current && current < dayjs().startOf('day');
    };

    const handleMarkChange = (e: any) => {
        setIsNegativemark(e.target.value);
    }

    const handleAutoChange = (e: any) => {
        setIsAutomate(e.target.value);
        setTotalMark(0);
        setQuestionCount(0);
        form.setFieldsValue({ "questionPaperA": "", "questionPapers": null, "automateQuestions": e.target.value });
        const value = form.getFieldsValue();
        if (value?.department) {
            getAutoQues(value?.department?.toString());
        }
    }
    const getAutoQues = (dept: string) => {
        const inputJson = {
            "question_type": "all",
            "department": dept
        }
        dispatch(autoGenerateQuestion(inputJson) as any);
    }


    const handleDurationChange = (e: any) => {
        setDuration(e);
        if (slots && slots.length > 0) {
            const updatedSlots = slots.map((slot: any) => {
                const startTime = dayjs(slot?.slotStartTime?.format('HH:mm a'), 'HH:mm a');
                if (!startTime?.isValid()) {
                    return slot; // Return the slot as is if the start time is invalid
                }

                const endTime = startTime.add(e, 'minute'); // e is the duration in minutes

                return {
                    ...slot,
                    slotEndTime: endTime, // Update the end time in HH:mm a format
                };
            });


            // Update the form fields with the new slot values
            // form.setFieldsValue({
            //     slots: updatedSlots,
            // });
        }
    }

    const handleCandidateChange = (value: any, name: any, index: number) => {
        const oldSlots = form.getFieldValue('slots') || [];

        // Deep clone the slots to avoid mutations
        const newSlots = oldSlots.map((slot: any, i: number) => {
            if (i === index) {
                return {
                    ...slot,
                    associateCandidates: [...value], // new array!
                };
            }
            return { ...slot }; // clone each slot
        });
        // Set updated slots to form
        form.setFieldsValue({ slots: newSlots });

        // Recalculate selected candidates across all slots
        const newSelected = new Set();
        newSlots.forEach((slot: any) => {
            (slot?.associateCandidates || []).forEach((id: any) => newSelected.add(id));
        });

        setSelectedCandidates(newSelected);
    };
    const loadData = () => {
        if (location.state.id == 0) {
            form.setFieldsValue({
                examTitle: "",
                examDate: null,
                description: '',
                totalQuestions: '',
                duration: '',
                questionPapers: null,
                associateCandidates: [],
                negativeMark: null,
                questionPaperA: "",
                "isNegativeMark": false,
                "automateQuestions": false,
                slots: slots,
                department: null,
                account: ""
            });
            setIsAutomate(false);
            setIsNegativemark(false);
            setQuestionCount(0);
            setTotalMark(0);
            setDept(null);
        } else {
            console.log("");
        }
    }

    const loadData1 = () => {
        if (examDetailInfo?.data && location.state.id !== 0) {
            const exmData = examDetailInfo?.data;
            const candidateVal = (examDetailInfo?.data?.associated_candidates !== "" && examDetailInfo?.data?.associated_candidates) ? examDetailInfo?.data?.associated_candidates?.split(',') : [];
            const date = dayjs(examDetailInfo?.data?.exam_date);
            setTotalMark(examDetailInfo?.data?.total_marks);
            if (examDetailInfo?.data?.exam_slots && examDetailInfo?.data?.exam_slots?.length > 0) {
                const acc = examDetailInfo?.data?.exam_slots?.[0]?.associated_accountid || 0;
                const dept = examDetailInfo?.data?.exam_slots?.[0]?.associated_department || null;
                setAccID(acc);
                getAppType(acc);
                getApplicList(acc, dept);
                getQuestions(dept);
            }
            const totalQues = examDetailInfo?.questionpapers_list?.reduce((sum: number, item: any) => {
                return sum + Number(item.total_question || 0);
            }, 0);
            setQuestionCount(examDetailInfo?.data?.total_marks || 0);
            const now = dayjs();
            const examDt = examDetailInfo?.data?.exam_date
                ? dayjs(examDetailInfo.data.exam_date)
                : null;
            const transformedSlots = examDetailInfo?.data?.exam_slots.map((slot: any, index: number) => {
                const date = dayjs(new Date(examDetailInfo?.data?.exam_date)).format("YYYY-MM-DD");
                const slotStart = dayjs(
                    `${date} ${slot.slot_start_time}`,

                );
                const isDisabled = slotStart.isBefore(now);
                return {
                    slotID: slot.id,
                    id: index + 1,
                    slotStartTime: dayjs(slot.slot_start_time, "HH:mm:ss"), // already includes date + time
                    slotEndTime: dayjs(slot.slot_end_time, "HH:mm:ss"),
                    location: slot.location,
                    isActive: slot.is_active,
                    associateCandidates: slot.associated_candidates,
                    disabled: isDisabled
                };
            });
            setSlots(transformedSlots);
            form.setFieldsValue({
                examTitle: exmData?.exam_title,
                examDate: exmData?.exam_date ? dayjs(new Date(exmData?.exam_date)) : null,
                description: examDetailInfo?.data?.description || '',
                totalQuestions: totalQues || '',
                duration: exmData?.exam_duration || '',
                // questionPapers: validQuesVals1 || [],
                associateCandidates: candidateVal || [],
                negativeMark: exmData.negative_mark || null,
                // slots: transformedSlots || slots,
                // questionPaperA: validQuesVals?.toString() || "",
                "isNegativeMark": examDetailInfo?.data?.is_negative_mark ? true : false,
                "automateQuestions": examDetailInfo?.data?.is_automate_questions ? true : false,
                account: Number(examDetailInfo?.data?.exam_slots?.[0]?.associated_accountid) || "",
                department: examDetailInfo?.data?.exam_slots?.[0]?.associated_department?.split(',') || null,
            });
            const depart = examDetailInfo?.data?.exam_slots?.[0]?.associated_department?.split(',') || null;
            setDept(depart);
            setDuration(exmData?.exam_duration || 0);
            setIsAutomate(examDetailInfo?.data?.is_automate_questions ? true : false);
            setIsNegativemark(examDetailInfo?.data?.is_negative_mark ? true : false);
            // const examDt = exmData?.exam_date ? dayjs(new Date(exmData?.exam_date)) : null;
            const isPastExam = examDt ? examDt?.isBefore(dayjs(), "day") : false;
            // Check if today and slot start time is past
            let isPastTime = false;

            if (examDt && examDt?.isSame(dayjs(), "day")) {
                isPastTime = exmData?.exam_slots?.some((slot: any) => {
                    const slotStart = dayjs(
                        `${exmData.exam_date} ${slot.slot_start_time}`,
                        "YYYY-MM-DD HH:mm"
                    );
                    return slotStart.isBefore(dayjs()); // true if this slot has already started
                });
            }
            setIsPastDate(isPastExam);
        }
        setIsLoaded(true);
    }
    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
        if (examDetailInfo?.data && location.state.id !== 0) {
            loadData1();
            form.setFieldsValue({ "questionPapers": null, "questionPaperA": "" });
        }
    }, [examDetailInfo?.data]);

    useEffect(() => {
        if (deptQuesInfo?.data && examDetailInfo && location.state.id !== 0) {

            // const paperA = form.getFieldValue('questionPaperA');
            const quesVala = examDetailInfo?.data?.associated_papers !== "" ? examDetailInfo?.data?.associated_papers?.split(',') : [];
            const validQuesVals = quesVala?.filter((val: any) =>
                sectionOptions1?.some((opt: any) => opt.value === val)
            );
            const paperA = validQuesVals?.toString() || "";
            const quesVal = examDetailInfo?.data?.associated_papers !== "" ? examDetailInfo?.data?.associated_papers?.split(',')?.filter((id: any) => id.trim() != paperA) : [];
            const validQuesVals1 = quesVal.filter((val: any) =>
                deptQuesInfo?.data?.map((opt: any) => opt.id == val));
            form.setFieldsValue({ "questionPapers": validQuesVals1 || [], "questionPaperA": paperA });
        }
    }, [deptQuesInfo?.data, examDetailInfo]);

    function getAppType(id: any) {
        const inputJson = {
            accountid: id?.toString(),
            qualification: "all",
            course: "all"
        }
        dispatch(getApplicantType(inputJson) as any);
    }
    const handleAccountChange = (e: any) => {
        getAppType(e);
        setAccID(e);
        form.setFieldsValue({ "department": null });
        setDeptOptions([]);
    }

    const handleDeptChange = (e: any) => {
        const val = e?.join(',');
        setDept(e);

        if (e?.length > 0) {
            getApplicList(accID, val);
            // getCandidate(accID, val);
            getQuestions(val);
        }
        if (isAutomate) {
            getAutoQues(val);
        }
    }

    const getApplicList = (accID: any, dept: string) => {
        const inputJson = {
            "status": "Active",
            "accountid": Number(accID) || 0,
            "department": dept || "CIVIL,Computer Science"
        }
        dispatch(getApplicantDetails(inputJson) as any);
    }

    function getQuestions(course: any) {
        const inputJson = {
            "course": course || "",
            "status": "Active"
        }
        dispatch(getDeptQuestions(inputJson) as any);
    }
    const handleQuestionType = (e: any) => {
        setQuestionType(e.target.value);
        if (e.target.value == '2') {
            const subject = autoPapers?.section_2_questions?.[fieldType]?.map((item: any) => {
                return {
                    value: item.department,
                    label: item.department
                }
            });
            setSubdeptOptions(subject);
            setSubdept(subject[0]?.value);
        }
    }

    const handleFieldType = (e: any) => {
        setFieldType(e.target.value);
        const val = e.target.value;
        const subject = autoPapers?.section_2_questions?.[val]?.map((item: any) => {
            return {
                value: item.department,
                label: item.department
            }
        });
        setSubdeptOptions(subject);
        setSubdept(subject[0]?.value);
    }
    const handleSubdeptChange = (e: any) => { setSubdept(e.target.value) }
    const callbackFunc = (val: any) => {

        setSlots((prevSlots: any) => {
            const exists = prevSlots.some((slot: any) => slot.id === val.id);

            if (exists) {
                // Update existing slot
                return prevSlots.map((slot: any) =>
                    slot.id === val.id ? { ...slot, ...val } : slot
                );
            } else {
                // Add new slot
                return [...prevSlots, val];
            }
        });
        closeSlot();
    }
    const handleEdit = (val: any) => {
        setRowData(val);
        setShowAdd(true);
    }

    const candidateIDs: any = slots?.flatMap((slot: any) => slot.associateCandidates) || [];

    const associatedDepartments = !loading18 && candidateIDs?.length > 0 ? applicantOptions
        ?.filter((a: any) => candidateIDs?.includes(a.id?.toString()))
        ?.map((a: any) => a.UG_course) : [];

    return (
        <div>
            <div className="my-3 px-0">
                <div className="row m-0">
                    <h5 className="my-auto col text-start ps-2 text-secondary fw-bold">{location.state.id === 0 ? 'Create Exam' : 'Update Exam'}</h5>
                    <div className="ms-auto col text-end my-auto pe-2">
                        <Button type="primary" className="col-auto ms-2 btn-back" onClick={goToPreviousScreen}>
                            Back
                        </Button>
                    </div>
                </div>
            </div>
            <Spin spinning={loading4 || loadingQuestions}>
                <div className="body-content-height mx-2 row">
                    <Form form={form} layout="vertical" preserve={false} className="col-md-4 bg-white p-2">
                        <div className='row mx-0 '>
                            <div className="px-2 py-3 ">
                                <div className="row m-0">
                                    <Form.Item className="col-md-6 px-2" label="Exam Title" name="examTitle"
                                        normalize={(value) =>
                                            value ? value.charAt(0).toUpperCase() + value.slice(1) : ''
                                        }
                                        rules={[{ required: true, message: 'This field is required' }]}>
                                        <Input disabled={isPastDate} />
                                    </Form.Item>
                                    <Form.Item className="col-md-6 col-lg-6 px-2" label="Date of Exam" name="examDate" rules={[{ required: true, message: 'This field is required' }]}>
                                        <DatePicker className="w-100" format="DD-MM-YYYY" disabledDate={disablePastDates} disabled={isPastDate} />
                                    </Form.Item>
                                    <Form.Item className="col-md-6 col-lg-6 px-2" label="Duration (In Minutes)" name="duration" rules={[{ required: true, message: 'This field is required' }]}>
                                        <InputNumber className="w-100" maxLength={3} onChange={(e) => handleDurationChange(e)} disabled={isPastDate} />
                                    </Form.Item>
                                    <Form.Item className="col-md-6 col-lg-6 px-2" label="Is Negative Mark" name="isNegativeMark" rules={[{ required: true, message: 'This field is required' }]}>
                                        <Radio.Group className='ms-1' onChange={(e) => handleMarkChange(e)} disabled={isPastDate} >
                                            <Radio value={true} >Yes </Radio>
                                            <Radio value={false} >No</Radio>
                                        </Radio.Group>
                                    </Form.Item>
                                    {isNegativemark ?
                                        <Form.Item className="col-md-6 col-lg-6 px-2" label="Negative Mark" name="negativeMark" rules={[{ required: true, message: 'This field is required' }]}>
                                            <InputNumber className="w-100" maxLength={3} disabled={isPastDate} />
                                        </Form.Item> : ""}
                                </div>
                                <div className={`row mx-0`}>
                                    {userID == "6" ?
                                        <Form.Item className="col ps-2 pe-2"
                                            label={<div className="d-flex w-100 "><span>Select Question Paper</span>
                                            </div>}
                                            name="questionPapers" rules={[{ required: true, message: 'This field is required' }]}>
                                            <Select
                                                className="w-100 "
                                                mode="multiple"
                                                maxCount={5}
                                                loading={loadingQuestions}
                                                options={sectionOptions3}
                                                getPopupContainer={(trigger) => trigger.parentNode}
                                                filterOption={(input: any, option: any) => (option?.label ?? '')?.toLowerCase().includes(input.toLowerCase())}
                                                onChange={handleChangeQuestion}
                                                onDeselect={handleChangeQuestion1}
                                                disabled={isPastDate}
                                                notFoundContent={
                                                    <div className="text-center p-4">
                                                        {loadingQuestions ? (
                                                            <span>
                                                                <LoadingOutlined />
                                                                Loading...
                                                            </span>
                                                        ) : (
                                                            <span>No question paper found</span>
                                                        )}
                                                    </div>
                                                }
                                            />
                                        </Form.Item> : <>
                                            <Form.Item
                                                name="account"
                                                className="col-md-12 px-2 mb-4"
                                                label="College"
                                                rules={[{ required: true, message: "This field is required" }]}
                                            >
                                                <Select options={accOptions} showSearch
                                                    filterOption={(input: any, option: any) => {
                                                        return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                                    }}
                                                    disabled={isPastDate}
                                                    filterSort={(optionA, optionB) => (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())}
                                                    onChange={handleAccountChange}
                                                    notFoundContent={
                                                        <div className="text-center p-4">
                                                            {accLoading ? (
                                                                <span>
                                                                    <LoadingOutlined />
                                                                    Loading...
                                                                </span>
                                                            ) : (
                                                                <span>No college found</span>
                                                            )}
                                                        </div>
                                                    } />
                                            </Form.Item>
                                            <Form.Item
                                                name='department'
                                                className="col-md-12 px-2"
                                                label="Specialisation"
                                                rules={[{ required: true, message: "This field is required" }]}
                                            >
                                                <Select mode="multiple"
                                                    options={deptOptions?.map((dept: any) => ({
                                                        ...dept,
                                                        disabled: associatedDepartments?.includes(dept.value)
                                                    }))}
                                                    showSearch
                                                    className='overflow-inner'
                                                    disabled={isPastDate}
                                                    filterOption={(input: any, option: any) => {
                                                        return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                                    }}
                                                    filterSort={(optionA, optionB) => (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())}
                                                    onChange={handleDeptChange}
                                                    notFoundContent={
                                                        <div className="text-center p-4">
                                                            {loading17 ? (
                                                                <span>
                                                                    <LoadingOutlined />
                                                                    Loading...
                                                                </span>
                                                            ) : (
                                                                <span>{accID == 0 ? "Select college to show department" : "No specialisation found"}</span>
                                                            )}
                                                        </div>
                                                    } />
                                            </Form.Item></>}
                                    <Form.Item className={`col-md-12 px-2`} label="Description" name="description"
                                        normalize={(value) =>
                                            value ? value.charAt(0).toUpperCase() + value.slice(1) : ''
                                        }>
                                        <TextArea rows={1} disabled={isPastDate} />
                                    </Form.Item>

                                </div>
                                {userID == "6" ? "" :
                                    <div className="row m-0">
                                        <Tooltip title={!dept ? "Select specialisation to generate questions" : ""}>
                                            <Form.Item className="col-md-6 col-lg-6 px-2" label="Automate Questions" name="automateQuestions" rules={[{ required: true, message: 'This field is required' }]}>
                                                <Radio.Group className='ms-1' onChange={(e) => handleAutoChange(e)} disabled={isPastDate || (!dept)}>
                                                    <Radio value={true} >Yes </Radio>
                                                    <Radio value={false} >No</Radio>
                                                </Radio.Group>
                                            </Form.Item>
                                        </Tooltip>

                                        {!isAutomate ? <>
                                            <Form.Item className="col-md-6 col-lg-6 px-2"
                                                label={<div className="d-flex w-100 "><span>Select Section A Paper</span></div>}
                                                name="questionPaperA" rules={[{ required: true, message: 'This field is required' }]} >
                                                <Select
                                                    className="w-100"
                                                    // mode="multiple"
                                                    loading={loading12}
                                                    options={sectionOptions1}
                                                    disabled={isPastDate}
                                                    getPopupContainer={(trigger) => trigger.parentNode}
                                                    filterOption={(input: any, option: any) => (option?.label ?? '')?.toLowerCase().includes(input.toLowerCase())}
                                                    onChange={handleChangeQuestionA}
                                                    onDeselect={handleChangeQuestion1}
                                                    notFoundContent={
                                                        <div className="text-center p-4">
                                                            {loading12 ? (
                                                                <span>
                                                                    <LoadingOutlined />
                                                                    Loading...
                                                                </span>
                                                            ) : (
                                                                <span>No question paper found</span>
                                                            )}
                                                        </div>
                                                    }
                                                />
                                            </Form.Item>
                                            <Form.Item className="col-md-12 col-lg-12 px-2"
                                                label={<div className="d-flex w-100 "><span>Select Section B Paper</span>
                                                </div>}
                                                name="questionPapers" rules={[{ required: true, message: 'This field is required' }]}>
                                                <Select
                                                    className="w-100 overflow-inner custom-height-select1"
                                                    mode="multiple"
                                                    // maxCount={5}
                                                    loading={loading12}
                                                    options={sectionOptions2}
                                                    disabled={isPastDate}
                                                    getPopupContainer={(trigger) => trigger.parentNode}
                                                    filterOption={(input: any, option: any) => (option?.label ?? '')?.toLowerCase().includes(input.toLowerCase())}
                                                    onChange={handleChangeQuestion}
                                                    onDeselect={handleChangeQuestion1}
                                                    notFoundContent={
                                                        <div className="text-center p-4">
                                                            {loading12 ? (
                                                                <span>
                                                                    <LoadingOutlined />
                                                                    Loading...
                                                                </span>
                                                            ) : (
                                                                <span>No question paper found</span>
                                                            )}
                                                        </div>
                                                    }
                                                />
                                            </Form.Item>
                                        </> : <div className="col-md-12 px-2 my-auto">{autoLoading ? <div className="d-flex flex-wrap"><Button type="primary" className="bg-warning" icon={<SyncOutlined spin />}>Generating question paper</Button></div> : <>
                                            {location.state.id !== 0 ? <div className="">
                                                {loading12 ? <Skeleton.Button active /> : <>
                                                    <h6 className="fw-bold col-md-12">Question Papers:</h6>
                                                    <div className='d-flex flex-wrap height-25 border overflow-auto p-2 bg-light'>
                                                        {deptQuesInfo?.data?.filter((item: any) => examDetailInfo?.data?.associated_papers ? examDetailInfo?.data?.associated_papers?.split(',')?.includes(item.id?.toString()) : null)?.map((item: any) => {
                                                            return (
                                                                <div key={item.id} className="bg-primary text-white p-2 d-inline-block col-auto mb-2 me-2 rounded">
                                                                    {item?.title}
                                                                </div>
                                                            )
                                                        })}</div></>}


                                            </div> :
                                                <div className="bg-aliceblue border p-2 my-auto">
                                                    <h6 className="fw-bold">Question Papers:</h6>
                                                    <span className="" onClick={handleOpenModal}><span className="text-blue text-decoration-underline pointer">Click here</span> to view the questions</span>
                                                </div>}</>}
                                        </div>}
                                    </div>}
                            </div>
                        </div>
                    </Form>
                    <div className="col bg-white p-3 ms-2">
                        <div className="d-flex py-2">
                            <h6 className="fw-bold my-auto">{showAdd ? rowData ? "Update Slot" : "Create Slot" : "Slot Details"}</h6>

                            <div className="col-auto ms-auto">
                                {showAdd ? <div>
                                    <Button type="primary" className="col-auto rounded-circle fs-20" icon={<ArrowLeftOutlined className='fs-20 fw-bold' />} onClick={closeSlot}></Button>
                                </div> :
                                    <Tooltip title={slots?.length >= 3
                                        ? "You have exceeded the maximum slot limit"
                                        : !duration
                                            ? "Please select duration"
                                            : !form.getFieldValue("account")
                                                ? "Please select college"
                                                : !dept
                                                    ? "Please select specialisation"
                                                    : ""}>
                                        <Button type="primary" onClick={() => handleShowSlot()} disabled={slots?.length == 3 || !duration || !form.getFieldValue('account') || !dept ? true : false}>Add Slot</Button>
                                    </Tooltip>}

                            </div>

                        </div>
                        {showAdd || slots?.length != 0 ? "" :
                            <div className="text-danger fs-14">
                                Note: Duration, College, Specialisation must be filled out to create new slot
                            </div>}
                        {showAdd ? <AddSlotScreen applicantOptions={applicantOptions} isPastDate={isPastDate} rowData={rowData} slots={slots} department={dept} duration={duration} callbackFunc={callbackFunc} /> : <>
                            {slots?.length == 0 ?
                                <div className="bg-light p-5 mb-3 text-muted text-center">
                                    No slot associated
                                </div> : <div>

                                    {slots?.map((item: any, index: number) => {
                                        const count = Number(index) + 1;
                                        return (
                                            <div key={index} className="mb-3 bg- border p-3 w-100 ">
                                                <div className="d-flex">
                                                    <div className='col-md-4'>
                                                        <h6 className='fs-15 fw-bold'>Slot Name</h6>
                                                        <span>{item?.location || "Slot " + count}</span>
                                                    </div>
                                                    <div className='col-md-2'>
                                                        <h6 className='fs-15 fw-bold'>Start Time</h6>
                                                        <span>{item?.slotStartTime ? dayjs(new Date(item?.slotStartTime))?.format('HH:mm:ss') : '--'}</span>
                                                    </div>
                                                    <div className='col-md-2'>
                                                        <h6 className='fs-15 fw-bold'>End Time</h6>
                                                        <span>{item?.slotStartTime ? dayjs(new Date(item?.slotEndTime))?.format('HH:mm:ss') : '--'}</span>
                                                    </div>
                                                    <div className='col-md-2 '>
                                                        <h6 className='fs-15 fw-bold'>Status</h6>
                                                        <span className={`${item.isActive ? 'text-success fw-bold' : !item.isActive ? 'text-danger fw-bold' : 'text-dark'}`}>{item?.isActive ? "Active" : "Inactive"}</span>
                                                    </div>
                                                    {isPastDate ? "" :
                                                        <div className="col-auto ms-auto ">
                                                            <div className="pointer" onClick={() => handleEdit(item)}><EditIcon size={30} /></div>
                                                        </div>}
                                                </div>
                                                <h6 className="col-md-12 fs-15 mt-4 fw-bold">Associated Applicants
                                                    {/* <div className="input-container">
                                                        <input type="text" name="text" className="input" placeholder="Search something...">
                                                        </input><svg xmlns="http://www.w3.org/2000/svg" fill="" viewBox="0 0 24 24" className="icon"><g strokeWidth="0" id="SVGRepo_bgCarrier"></g><g strokeLinejoin="round" strokeLinecap="round" id="SVGRepo_tracerCarrier"></g><g id="SVGRepo_iconCarrier"> <rect fill="white" height="24" width="24"></rect> <path fill="" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM9 11.5C9 10.1193 10.1193 9 11.5 9C12.8807 9 14 10.1193 14 11.5C14 12.8807 12.8807 14 11.5 14C10.1193 14 9 12.8807 9 11.5ZM11.5 7C9.01472 7 7 9.01472 7 11.5C7 13.9853 9.01472 16 11.5 16C12.3805 16 13.202 15.7471 13.8957 15.31L15.2929 16.7071C15.6834 17.0976 16.3166 17.0976 16.7071 16.7071C17.0976 16.3166 17.0976 15.6834 16.7071 15.2929L15.31 13.8957C15.7471 13.202 16 12.3805 16 11.5C16 9.01472 13.9853 7 11.5 7Z" clipRule="evenodd" fillRule="evenodd"></path> </g></svg>
                                                    </div> */}
                                                </h6>
                                                {loading18 ? <Skeleton active /> : <>
                                                    {!item?.associateCandidates && item?.associateCandidates == '' ?
                                                        <div className="bg-light p-3 text-center">No applicants associated</div> :
                                                        <div className="d-flex flex-wrap my-2 candidate-height-container">
                                                            {applicantOptions
                                                                ?.filter((itm: any) => {
                                                                    if (!item?.associateCandidates) return false;

                                                                    if (item.associateCandidates.includes(",")) {
                                                                        // Case: multiple IDs
                                                                        return item.associateCandidates
                                                                            .split(",")
                                                                            .includes(itm.id?.toString());
                                                                    } else {
                                                                        // Case: single ID
                                                                        return item.associateCandidates === itm.id?.toString();
                                                                    }
                                                                })
                                                                ?.map((itm: any) => (
                                                                    <div
                                                                        key={itm.id}
                                                                        className="bg-aliceblue border p-2 col-auto me-2 mb-2 shadow-sm"
                                                                    >
                                                                        <span className="fw-bold text-secondary">
                                                                            {itm.fname + " " + itm.lname}
                                                                        </span>
                                                                        <div className="fs-13 my-1">{"(" + itm.UG_course + ")"}</div>
                                                                        <div className="fs-13">{itm.email}</div>
                                                                    </div>
                                                                ))}

                                                        </div>}</>}
                                                <div>

                                                </div>
                                            </div>
                                        )
                                    })}</div>}
                        </>}

                    </div>

                </div>
                {isPastDate ? "" :
                    <div className="row mx-0 mt-3 ps-3 pe-3 mb-3">
                        <Button type="default" className="col-auto ms-auto bg-secondary text-white rounded-0 me-2" onClick={goToPreviousScreen}>
                            Cancel
                        </Button>
                        <Button type="primary" className="col-auto me-0" disabled={showAdd} onClick={submitForm} loading={loading1}>
                            Save
                        </Button>
                    </div>
                }
            </Spin>
            <Modal title="Auto Generated Questions" open={openModal} onCancel={closeModal} width={1200}
                footer={[
                    <Button key="back" onClick={closeModal}>
                        Cancel
                    </Button>

                ]}>
                <div>
                    <Radio.Group defaultValue={questionType} onChange={handleQuestionType}>
                        <Radio value="1" className="fw-bold fs-16">Aptitude</Radio>
                        <Radio value="2" className="fw-bold fs-16">Technical</Radio>
                    </Radio.Group>
                    {questionType == '2' ?
                        <div className="mb-3 mt-2 p-3 border d-flex w-100 bg-light">
                            <div className="col me-2">
                                <h6 className="fs-15">Select Preferred Field</h6>
                                <Radio.Group defaultValue={fieldType} onChange={handleFieldType}>
                                    <Radio value="core_questions">Core</Radio>
                                    <Radio value="it_questions">IT</Radio>
                                    <Radio value="core_it_questions">Core/IT</Radio>
                                </Radio.Group>
                            </div>
                            {fieldType == 'it_questions' ? "" : <div className="col ms-2">
                                <h6 className="fs-15">Select department</h6>
                                <Radio.Group defaultValue={subdept} onChange={handleSubdeptChange}>
                                    {subdeptOptions?.map((item: any) => {
                                        return <Radio key={item.value} value={item.value}>{item.label}</Radio>
                                    })}
                                    {/* <Radio value="core_questions">Core</Radio>
                                    <Radio value="it_questions">IT</Radio>
                                    <Radio value="core_it_questions">Core/IT</Radio> */}
                                </Radio.Group>
                            </div>}

                        </div> : ""}
                    {questionType == '1' ?
                        <div className="my-3 p-2 bg-light question-list-cont-modal custom-scrollbar row mx-0 overflow-auto">

                            {autoPapers?.section_1_questions?.map((item: any, index: number) => {
                                return (
                                    <div key={item.id} className=" d-flex mb-3 col-md-6">
                                        <div className="question-cntr border ms-2 w-100">
                                            <div className="bg-lightPrimary d-flex p-2 align-items-start">
                                                <div>
                                                    <span className="text-secondary fw-bold pe-3">( {index + 1} )</span>
                                                    <span className="author-name fw-bold text-gray pe-4">{item.Mdquestions_name}</span>{' '}
                                                    {item.question_image ? <Image src={window.origin+"/" + item.question_image} height={50} /> : ""}
                                                    {/* <span className="text-dark">System Admin</span> */}
                                                </div>
                                                {/* <div className="ms-5 text-dark">
                                                                                        <span className=" fw-bold text-gray">Updated on: </span> <span className="text-dark">{date.format('DD-MM-YYYY HH:mm')}</span>
                                                                                    </div> */}
                                                <div className="ms-auto d-flex qus-opr">
                                                    <div className="pe-1 my-auto">
                                                        <DownCircleFilled
                                                            className={`${item.level_of_difficulty == 'easy' ? 'text-success bg-success' : item.level_of_difficulty == 'medium' ? 'text-warning bg-warning' : 'text-danger bg-danger'} rounded-circle`}
                                                        />
                                                    </div>
                                                    <div className="text-primary ms-1 mb-0 mt-1 pointer my-auto" onClick={() => handleExpand(item.id)}>
                                                        {expandVal?.includes(item.id) ? <DownSquareOutlined className="fs-17" rotate={-90} /> : <DownSquareOutlined className="fs-17" />}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={`p-2 d-flex question-contn bg-white ${expandVal?.includes(item.id) ? 'incheight' : ''}`}>
                                                <div className="ps-2 pe-4 w-100">
                                                    {/* <span className="question text-dark fs-16">{item.Mdquestions_name}</span> */}
                                                    <div className="row m-3">
                                                        {item.Mdquestions_type === "inputfield" || item.Mdquestions_type == "input" ? <div className="fw-bold fs-15">
                                                            <span className="text-success">
                                                                {item.answer}
                                                            </span>
                                                        </div> : <>
                                                            {item.options?.map((opt: any, i: number) => {
                                                                return (
                                                                    <div className={`col-md-6 d-flex ${i % 2 == 0 ? 'ps-0' : 'pe-0'}`} key={i}>
                                                                        <div className={`p-2 w-100 mb-2 fs-15 ${opt.answer_option ? 'text-success fw-bold' : 'text-gray '}`}>
                                                                            <span className={`option-name fw-bold ${opt.answer_option ? 'text-success' : 'text-gray '}`}>
                                                                                {String.fromCharCode(i + 65)}
                                                                            </span>
                                                                            <span className="ms-2 option"> {opt?.option_image ? <Image src={window.origin+"/api" + opt.option_image} height={50} /> : opt.option_name}</span>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}</>}
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div> :

                        <div className="my-3 p-2 bg-light question-list-cont-modal custom-scrollbar mx-0 overflow-auto">
                            {autoPapers?.section_2_questions?.[fieldType]?.filter((itm: any) => itm.department == subdept)?.map((itm: any, ind: number) => {
                                return (
                                    <div key={ind} className="row">
                                        {itm.questions?.map((item: any, index: number) => {
                                            return (
                                                <div key={index} className="d-flex mb-3 col-md-6">
                                                    <div className="question-cntr border ms-2 w-100">
                                                        <div className="bg-lightPrimary d-flex p-2 align-items-start">
                                                            <div>
                                                                <span className="text-secondary fw-bold pe-3">( {index + 1} )</span>
                                                                <span className="author-name fw-bold text-gray pe-4">{item.Mdquestions_name}</span>{' '}
                                                                {item.question_image ? <Image src={window.origin+"/api" + item.question_image} height={50} /> : ""}
                                                                {/* <span className="text-dark">System Admin</span> */}
                                                            </div>
                                                            {/* <div className="ms-5 text-dark">
                                                                                        <span className=" fw-bold text-gray">Updated on: </span> <span className="text-dark">{date.format('DD-MM-YYYY HH:mm')}</span>
                                                                                    </div> */}
                                                            <div className="ms-auto d-flex qus-opr">
                                                                <div className="pe-1 my-auto">
                                                                    <DownCircleFilled
                                                                        className={`${item.level_of_difficulty == 'easy' ? 'text-success bg-success' : item.level_of_difficulty == 'medium' ? 'text-warning bg-warning' : 'text-danger bg-danger'} rounded-circle`}
                                                                    />
                                                                </div>
                                                                <div className="text-primary ms-1 mb-0 mt-1 pointer my-auto" onClick={() => handleExpand(item.id)}>
                                                                    {expandVal?.includes(item.id) ? <DownSquareOutlined className="fs-17" rotate={-90} /> : <DownSquareOutlined className="fs-17" />}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className={`p-2 d-flex question-contn bg-white ${expandVal?.includes(item.id) ? 'incheight' : ''}`}>
                                                            <div className="ps-2 pe-4 w-100">
                                                                {/* <span className="question text-dark fs-16">{item.Mdquestions_name}</span> */}
                                                                <div className="row m-3">
                                                                    {item.Mdquestions_type === "inputfield" || item.Mdquestions_type == "input" ? <div className="fw-bold fs-15">
                                                                        <span className="text-success">
                                                                            {item.answer}
                                                                        </span>
                                                                    </div> : <>
                                                                        {item.options?.map((opt: any, i: number) => {
                                                                            return (
                                                                                <div className={`col-md-6 d-flex ${i % 2 == 0 ? 'ps-0' : 'pe-0'}`} key={i}>
                                                                                    <div className={`p-2 w-100 mb-2 fs-15 ${opt.answer_option ? 'text-success fw-bold' : 'text-gray '}`}>
                                                                                        <span className={`option-name fw-bold ${opt.answer_option ? 'text-success' : 'text-gray '}`}>
                                                                                            {String.fromCharCode(i + 65)}
                                                                                        </span>
                                                                                        <span className="ms-2 option"> {opt?.option_image ? <Image src={window.origin+"/api"+ opt.option_image} height={50} /> : opt.option_name}</span>
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        })}</>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}

                                    </div>
                                )
                            })}
                        </div>}
                </div>
            </Modal>
        </div>
    );
};

export default NewUpdateExam;
